import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Progress } from 'reactstrap';
import { Grid } from '@material-ui/core'
import { isUndefined} from 'lodash'
import { sv } from "date-fns/locale";
import moment from 'moment';
import {format}  from 'date-fns';
import { withStyles } from '@material-ui/styles';
import compose from 'recompose/compose';
import {isEmpty} from 'lodash'
import {NumberFormat} from 'components/NotyNumberFormat'
import { getUtfalldiagramSByAfid,setofUpdatedashboard } from 'actions'
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
  const { authUser} = auth;
  const { updatedashboard,DashBoardValueOf} = accountsData;
  const { UtfallSdiagram,DashboardSaljFilterOption} = DashBoard;
  return {
      UtfallSdiagram,DashboardSaljFilterOption,authUser,updatedashboard,DashBoardValueOf
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getUtfalldiagramSByAfid: (Afid,userid,FilterOption) => dispatch(getUtfalldiagramSByAfid(Afid,userid,FilterOption)),
    setofUpdatedashboard: () => dispatch(setofUpdatedashboard()),
    dispatch
  };
}
const styles = props => ({
    MainProgress: {
        backgroundColor: '#12585E !important',
        height:"2.4rem !important",
        borderRadius:"30px",
    }
  });
class ProgresBarBudget extends Component {
    state={
      UtfallSdiagram:{utfall:0,budget:100},
      DashboardSaljFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
      done: false
    }
    intervalID = null
    componentDidMount=()=>{
      const Afid = this.props.Afid;
      
      this.props.getUtfalldiagramSByAfid(Afid,undefined,this.state.DashboardSaljFilterOption).then(() => { 
        this.initiateInterval()
        this.setState({done: true})
     })        
    }
    initiateInterval () {
      clearInterval(this.intervalID);
      this.intervalID = null 
      this.intervalID = setInterval(
          () => {
              if(this.state.done === true){ 
                  this.setState({done: false,})
                  const Afid = this.props.Afid;
                  this.props.getUtfalldiagramSByAfid(Afid,undefined,this.state.DashboardSaljFilterOption).then(() => { 
                      this.initiateInterval()
                      this.setState({done: true})
                   })
              }
          },
          180000
      );
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    componentDidUpdate=()=>{
      const Afid = this.props.Afid;
      if(parseInt(this.props.updatedashboard) === 1){
        this.props.getUtfalldiagramSByAfid(Afid,undefined,this.state.DashboardSaljFilterOption).then(() => { 
          this.initiateInterval()
          this.setState({done: true})
       })
        this.props.setofUpdatedashboard()
      }
        if(this.props.DashboardSaljFilterOption !== this.state.DashboardSaljFilterOption && !isEmpty(this.props.DashboardSaljFilterOption))
          {
                
              
              this.props.getUtfalldiagramSByAfid(Afid,undefined,this.state.DashboardSaljFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
              this.setState({
                  DashboardSaljFilterOption:this.props.DashboardSaljFilterOption 
              }) 
          }
      }
      getDashBoardValueOf = ()=>{
        try{
        let ModuleValue = JSON.parse(this.props.DashBoardValueOf).find(item=>parseInt(item.DashBaord) === 3)
        if(ModuleValue.Value > 2 && ModuleValue.Value !== 5){
            return 2
        }else{
            return 1
        }}
        catch(error){return 1}
    }
    formatNumber=(number)=>{
      const _ValueOF = this.getDashBoardValueOf()
      return NumberFormat(number,  _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
       
    }
    componentDidUpdate=()=>{
        if(!isUndefined(this.props.UtfallSdiagram)){
            if(this.props.UtfallSdiagram !== this.state.UtfallSdiagram){
                this.setState({
                    UtfallSdiagram:this.props.UtfallSdiagram
                })
            }
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                 <div className="text-center text-white d-flex align-items-center justify-content-center mb-3">
                <h2 style={{ paddingTop: '12px', margin: '0', marginRight: '0.5rem', fontWeight: '500', fontSize: 20 }}><IntlMessages id="Outcome.Budget"/></h2>
                <p style={{ paddingTop: '12px', fontSize:"14px", textTransform:"capitalize" }}>(
                {
                    isEmpty(this.props.DashboardSaljFilterOption.filter(item=>item.Meta === "DatumFrom" || item.Meta === "DatumTo"))?
                    `${format(new Date(), 'MMMM', { locale: sv })}`
                    :
                    <>
                    {`
                    ${
                        isEmpty(this.props.DashboardSaljFilterOption.filter(item=>item.Meta === "DatumFrom"))?
                        moment(new Date()).format('YYYY-MM-DD'):
                        moment(this.props.DashboardSaljFilterOption.filter(item=>item.Meta === "DatumFrom")[0].Value).format('YYYY-MM-DD')
                    }
                    -
                    ${
                        isEmpty(this.props.DashboardSaljFilterOption.filter(item=>item.Meta === "DatumTo"))?
                        moment(new Date()).format('YYYY-MM-DD'):
                        moment(this.props.DashboardSaljFilterOption.filter(item=>item.Meta === "DatumTo")[0].Value).format('YYYY-MM-DD')
                    }
                    `}
                    </>
                    
                }    
                )</p>
            </div>
                <Grid
                  container
                  direction="row"
                  justify="center"
                  alignItems="center"
                  className="p-4"
                >
                  <Grid item xs={12}  className="px-2 text-white" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '-1.3rem' }}>
                  {
                     this.state.done === false?  
                     <Skeleton variant="rectangular" height={40} width={100} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                     :
                    parseInt(this.props.Flags?.DashboardSaljFormat) === 0 ?
                    <>
                      <div style={{ fontSize: '1.2rem' }}>{this.formatNumber(parseInt(this.state.UtfallSdiagram.utfall))} <span style={{ fontSize: '0.7rem' }}>{parseInt(this.state.UtfallSdiagram.utfall) < 1000 ? 'SEK' : ''}</span> </div>
                      <div style={{ fontSize: '1.2rem' }}>/ {this.formatNumber(parseInt(this.state.UtfallSdiagram.budget))} <span style={{ fontSize: '0.7rem' }}>{parseInt(this.state.UtfallSdiagram.budget) < 1000 ? 'SEK' : ''}</span></div>
                    </>
                    : ''
                  }
                  </Grid>
                  <Grid item xs={12}>
                  {
     this.state.done === false?  
     <Skeleton variant="rectangular" height={50} width={"100%"} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
     :
                    <Progress multi className={classes.MainProgress}>
                      <Progress bar
                      //  color={parseInt(this.state.UtfallSdiagram.utfall)>=parseInt(this.state.UtfallSdiagram.budget)?"success":"defaultNoty2"}
                      style={{ backgroundColor: parseInt(this.state.UtfallSdiagram.utfall)>=parseInt(this.state.UtfallSdiagram.budget)? '#77ED9C' : '#44D1C2'}}
                      value={parseInt(this.state.UtfallSdiagram.utfall)} 
                      max={parseInt(this.state.UtfallSdiagram.utfall)>=parseInt(this.state.UtfallSdiagram.budget)?parseInt(this.state.UtfallSdiagram.utfall):parseInt(this.state.UtfallSdiagram.budget)}
                      >
                        <p
                          style={{fontSize:"1.3rem", fontWeight:"700", color: '#075A5F'}}
                          > {parseInt((this.state.UtfallSdiagram.utfall/this.state.UtfallSdiagram.budget)*100)} %</p>
                      </Progress>
              
                    </Progress> }
                  </Grid>
                </Grid>
            </div>
        );
    }
}

export default  compose(
    connect(
        mapStateToProps,mapDispatchToProps
    ),
    withStyles(styles)
    )(ProgresBarBudget);